export default "__VITE_PUBLIC_ASSET__c594d52a__"